import { useNavigate } from 'react-router-dom'
import routes from '@/routes/routes'
import { useEffect } from 'react'
import Button from '@/components/common/Button/Button'
import './RequestCreate.css'

const RequestCreate = () => {
    const navigate = useNavigate()

    useEffect(() => {
        const timer = setTimeout(() => navigate(routes.serviceSearch), 3000)
        return () => clearTimeout(timer)
    }, [navigate])

    return (
        <div className="request-create-page">
            <div className="request-create-content">
                <h2>Redirigiendo...</h2>
                <p>Para solicitar un servicio, por favor:</p>
                <ol className="request-create-steps">
                    <li>Busca el servicio que necesitas</li>
                    <li>Selecciona un proveedor</li>
                    <li>Elige la hora en su horario disponible</li>
                </ol>
                <Button variant="primary" onClick={() => navigate(routes.serviceSearch)} effect3d={false}>
                    Ir a Servicios
                </Button>
            </div>
        </div>
    )
}

export default RequestCreate


